import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { ReleasePhaseIcon } from './ReleasePhaseIcon';
import { ReleasePhaseName } from './ReleasePhaseName';

export class ReleasePhaseFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [ReleasePhaseIcon, ReleasePhaseName];
  }

  get title() {
    return terminology('Release phase');
  }
}
